<template>
  <div class="container">
    <v-row class="row my-n4">
      <v-col cols="auto">
        <router-link
          class="d-flex align-center white--text title-predi"
          :to="{
            name: 'home',
          }"
        >
          <h1 class="logo-predi">
            PRE<span>distribuce</span>
          </h1>
          <div class="logo-sidetitle ml-8 pl-8">
            DISTRIBUČNÍ PORTÁL
          </div>
          <div class="logo-sidetitle ml-8 pl-8" v-if="showMaintenanceMessage">
            <span class="text-caption ml-3" style="color: rgb(255 209 140)">
              {{ maintenanceMessage }}
            </span>
          </div>
        </router-link>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import http from '@/http';

export default {
  name: 'TheHeader',
  data() {
    return {
      showMaintenanceMessage: false,
      maintenanceMessage: null,
      messageCheckFrequency: 60000,
      messagesTimeout: null,
    };
  },
  methods: {
    getMessages() {
      if (this.$store.state.auth.accessToken != null) {
        http
          .get('gateway-messages')
          .then((response) => {
            const messages = response.data;
            if (messages != null && messages.length > 0) {
              // eslint-disable-next-line prefer-destructuring
              this.maintenanceMessage = messages[0].message;
              this.showMaintenanceMessage = true;
            } else {
              this.maintenanceMessage = '';
              this.showMaintenanceMessage = false;
            }
            if (this.messagesTimeout) {
              clearTimeout(this.messagesTimeout);
            }
            this.messagesTimeout = setTimeout(this.getMessages, this.messageCheckFrequency);
          })
          .catch((err) => {
            console.log(err);
            if (this.messagesTimeout) {
              clearTimeout(this.messagesTimeout);
            }
            this.messagesTimeout = setTimeout(this.getMessages, this.messageCheckFrequency);
          });
      }
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    '$store.state.auth.accessToken': function (newVal) {
      if (newVal != null) {
        this.getMessages();
      }
    },
  },
  created() {
    this.getMessages();
  },
};
</script>

<style lang="scss">
@import '../scss/utilities/px-to-rem';

.logo-predi {
  font-weight: normal;
  @include rem(font-size, 36px);
}

.logo-predi span {
  font-weight: 300;
}

.title-predi {
  text-decoration: none;
}

.logo-sidetitle {
  position: relative;
  color: #fff;
  @include rem(font-size, 16px);
  text-transform: uppercase;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    height: 40px;
    width: 1px;
    background: rgba(255, 255, 255, 0.35);
  }
}
</style>
